// extracted by mini-css-extract-plugin
export default {"cursor":"typewriter-text_cursor__mIHK1","blink":"typewriter-text_blink__Q+uVw"};